import React, { ReactNode, useState } from 'react'
import { Header } from '@epo/epods-react-components/lib/Components/Header'
import { Button } from '@epo/epods-react-components/lib/Components/Button'
import { Drawer } from '@epo/epods-react-components/lib/Components/Drawer'
import { EPOLogoBase64 } from '@epo/epods-react-components/lib/Components/Header'
import { Dropdown } from '@epo/epods-react-components/lib/Components/Dropdown'
import { useSelector, useDispatch } from 'react-redux';
import { AppDispatch, selectors, actions } from '../store/store';
import { Language } from '../types/enums'
import { changeDropdownLanguage } from '../hooks/change-dropdown-language.hook'
import { isEmpty } from 'lodash'
import useTranslation from '../hooks/use-translation.hook';
import { setStorageItem } from '../helpers/storage'
import questionmark from '../assets/images/questionmark.svg'
import useQueryParams from '../hooks/useQuery'
import { useLocation } from 'react-router-dom'

type LayoutProps = {
    children: ReactNode
}

const MainLayout: React.FC<LayoutProps> = ({ children }: LayoutProps) => {
    const location = useLocation();
    const { hash, pathname, search } = location;

    console.log('Search params:', search);
    console.log('hash:', hash);
    console.log('--------------')

    const { query, setQueryParams } = useQueryParams();
    const { formatMessage: m } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const [activeUtility, setActiveUtility] = useState(false);

    const language = useSelector(selectors.settings.selectLanguage);
    const rigiLanguage = useSelector(selectors.settings.selectRigiLanguage);

    const displayLanguage = isEmpty(rigiLanguage) ? language : rigiLanguage

    const listLanguages = [
        { label: Language.EN, id: Language.EN },
        { label: Language.FR, id: Language.FR },
        { label: Language.DE, id: Language.DE },
    ]

    const footerLinks = [
        { label: m({ id: 'footer.legalNotice' }), href: 'https://www.epo.org/en/legal-notice' },
        { label: m({ id: 'footer.termsOfUse' }), href: 'https://www.epo.org/en/terms-of-use' },
        { label: m({ id: 'footer.dataProtection' }), href: 'https://www.epo.org/en/about-us/office/data-protection-and-privacy' },
        { label: m({ id: 'footer.accesibility' }), href: 'https://www.epo.org/en/accessibility' },
    ]

    const RightSideControls = () => {
        const defaultConfig = {
            create: false,
            notifications: false,
            userProfile: false,
        };
        const [activeKeyDrawer, setActiveKeyDrawer] = React.useState(defaultConfig);

        return (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Dropdown
                    id='epo-language-dropdown'
                    name='epo-language-dropdown'
                    data-nua='language-dropdown'
                    preset='select'
                    size='default'
                    aria-label={m({
                        id: 'applicationMenu.languageDropdown.item.ariaLabel',
                    })}
                    maxDropdownHeight='300px'
                    value={[{ id: displayLanguage }]}
                    onChange={(params: any) => {
                        changeDropdownLanguage(
                            params.option.id,
                            params.option.id,
                            params.option.id,
                        );

                        dispatch(
                            actions.settings.updateLanguage(params.option.id),
                        )
                        dispatch(actions.settings.updateRigiLanguage(''));
                        setStorageItem('language', params.option.id);
                        setQueryParams({ ...query, ...{ lang: params.option.id } })
                    }}
                    options={listLanguages}
                    ControlContainerStyle={{ width: '80px' }}
                />
                <Button
                    theme="toggle"
                    className="h-100 border-0 rounded-0 ml-s"
                    isSelected={activeKeyDrawer['notifications']}
                    onClick={() => setActiveKeyDrawer({ ...defaultConfig, notifications: true })}
                >
                    <img src={questionmark} alt="questionmark" />
                </Button>
            </div>
        );
    };

    return (
        <div className='w-100 vh-100'>
            <div className='w-100 h-100 overflow-hidden bg-canvas text-primary d-flex flex-column' style={{ zIndex: 1 }}>
                <Header
                    logo={EPOLogoBase64}
                    appName={`${m({ id: 'header.title' })}`}
                    leftSide={<></>}
                    rightSide={<RightSideControls />}
                    backgroundColor="white"
                    zIndex={9999}
                    className='p-s'
                />
                <div className='container bg-body flex-grow-1 mx-0 scrollable-y'>
                    <div className="App bg-light container-fluid" style={{}}>
                        <div className="container-fluid" style={{ maxWidth: '1450px' }}>
                            <div className='p-xl' style={{ background: '#fff', minHeight: '95vh' }}>
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='text-inverted bg-ds-dark p-l'>
                    <div className="d-flex mx-m" style={{ gap: 'var(--epods--space-inset-l)' }}>
                        {footerLinks.map((linkItem, index) => (
                            <a className='text-inverted' key={index} href={linkItem.href} target='_blank'>{linkItem.label}</a>
                        ))}
                    </div>
                </div>
            </div>
            <div style={{ zIndex: 2 }}>
                <Drawer isOpen={activeUtility} onClose={() => setActiveUtility(false)}>
                    <h2>Drawer Content</h2>
                </Drawer>
            </div>
        </div>
    )
}

export default MainLayout